/**
 * <ApplicationForm
 *	 onChange={}
 *	/>
 *
 * @parent TicketFormAccordion
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import locale from './locale';
import DOBPicker from 'components/UI/DOBPicker';
import ReactPhoneInput from 'components/Form/Fields/PhoneNumber';
import _ from 'lodash';

import './ApplicationForm.scss'

const DEFAULT_REGION_CODE = 'ca';
const validateRules = {
  first_name: ['required'],
  last_name: ['required'],
  email: ['email'],
  phone: ['phone'],
}


class ApplicationForm extends React.Component {
  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(props) {
    super(props);

    let formData = {...props.formData, phoneParsed: {country_code: '1', national_number: '', region_code: DEFAULT_REGION_CODE}}

    this.state = {
      formData: formData,
      formError: {},
    }

    this.onTextChange = this.onTextChange.bind(this);
    this.onValueChange = this.onValueChange.bind(this);
    this.onPhoneChange = this.onPhoneChange.bind(this);
    this.input = this.input.bind(this);
  }

  // we register our validation function, when the component is loaded.
  // these functions are saved in an array which is iterated as the form
  // is submitted.
  componentDidMount() {
    this.props.registerValidate((validateFunction)=>{
      return ()=>{
        const { formData } = this.state;
        const { canSubmit, formError } = validateFunction(formData, validateRules);

        this.setState({
          formError
        });

        return canSubmit;
      }
    });
  }

  componentWillReceiveProps({ formData }) {
    this.setState({
      formData:{
        ...this.state.formData,
      }
    });
  }

  onTextChange(name) {
    return ({target}) => {
      this.setState({
        formData: {
          ...this.state.formData,
          [name]: target.value,
        }
      }, ()=>{
        this.props.onChange(this.state.formData);
      })
    }
  }

  onValueChange(name) {
    return (value) => {
      this.setState({
        formData: {
          ...this.state.formData,
          [name]: value,
        }
      }, ()=>{
        this.props.onChange(this.state.formData);
      })
    }
  }

  onPhoneChange(name) {
    return (value) => {
      this.setState({
        formData: {
          ...this.state.formData,
          [name]: value,
        }
      }, ()=>{
        this.props.onChange(this.state.formData);
      })
    }
  }

  render() {
    const { isLastForm, index, onDelete } = this.props;
    const { formData, formError } = this.state;

    return (
      <div className='application-form-wrapper'>
        <div className={classnames('application-form', { isLastForm })}>
          <div className='col-sm-12 form-group'>
            <h5>{__('Applicant Information', locale)} {index + 1}</h5>
            <i className="fa icon-cancel" onClick={()=>onDelete(index)}></i>
          </div>

          {this.input({ label: __('First Name', locale), name: 'first_name', className:'col-sm-6', required: true, })}
          {this.input({ label: __('Last Name', locale), name: 'last_name', className:'col-sm-6', required: true, })}

          <div className={classnames('col-sm-12 form-group', { hasError: formError['date_of_birth'] })}>
            <label>{__('Date Of Birth', locale)}</label>
            <DOBPicker value={formData['date_of_birth']} onChange={(momentObj)=>{ this.onValueChange('date_of_birth')(momentObj.format('YYYY-MM-DD')); }} />
            {/* <div className='error-msg'>{formError['date_of_birth']}</div> */}
          </div>

          {this.input({ label: __('Applicant\'s Email', locale), name: 'email', className:'col-sm-12' })}
          <div className='col-sm-12 form-group'>
            <label>{__('Applicant\'s Phone', locale)}</label>
            <ReactPhoneInput
              inputStyle={{height: '40px'}}
              className='form-control'
              defaultCountry={'ca'}
              value={formData['phoneParsed']}
              onChange={this.onPhoneChange('phoneParsed')}
              onlyCountries={['ca', 'us']}
              disableAreaCodes={true}
            />
          </div>
        </div>
      </div>
    )
  }

  input({ label, name, className, required }) {
    const { formData, formError } = this.state;
    return (
      <div className={classnames(className || '', 'form-group', { hasError: formError[name] })}>
        <label>{label}{ required && <span className='required'>*</span> }</label>
        <input value={formData[name]} type='text' onChange={this.onTextChange(name)}/>
        <div className='error-msg'>{formError[name]}</div>
      </div>
    );
  }
}

export default ApplicationForm;



// WEBPACK FOOTER //
// ./src/shared/RegisterClassModal/ApplicationForm.js